export const prefixApi: string = '/api';
